import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    badge: {
        backgroundColor: '#14b8a6',
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: 500,
        borderRadius: '9999px',
        padding: '4px 12px',
    },
}));

interface TimelineBadgeProps {
    count: number;
    type: string;
}

export const TimelineBadge: React.FC<TimelineBadgeProps> = ({ count, type }) => {
    const classes = useStyles();
    return (
        <Box className={classes.badge}>
            <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
                {count} {type}
            </Typography>
        </Box>
    );
};
